import styled from 'styled-components';
import { BaseChartContainer } from './common-charts-styles';
import { HorizontalBar } from 'react-chartjs-2';

export const HorizontalChartContainer = styled(BaseChartContainer)`
  ${HorizontalBar} {
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 40rem) {
    ${HorizontalBar} {
      max-width: 14rem;
    }
  }
`;
